import { createReduxSagaActionSubtypes as createSubtypes } from '@/utils/create-redux-saga-action-subtypes';

export const TasksActionTypes = {
  FETCH_OPEN_TASKS_COUNTERS: createSubtypes('tasks|fetchOpenTasksCounters'),
};
